/* eslint-disable import/prefer-default-export */
export const VueNumericDirective = {
  bind(el) {
    // eslint-disable-next-line no-param-reassign
    el.onkeypress = (evt) => {
      const event = (evt) || window.event;
      const key = event.which || event.keyCode || event.charCode;

      if (key > 31 && (key < 35 || key > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
      return false;
    };
  },
};
